import { render } from "./QnrTable.vue?vue&type=template&id=c93ce128"
import script from "./QnrTable.vue?vue&type=script&lang=ts"
export * from "./QnrTable.vue?vue&type=script&lang=ts"
script.render = render

export default script